

export const index = 1;
export const component = async () => (await import('../entries/fallbacks/error.svelte.js')).default;
export const file = '_app/immutable/components/error.svelte-843db4b3.js';
export const imports = ["_app/immutable/components/error.svelte-843db4b3.js","_app/immutable/chunks/index-ae03fd13.js","_app/immutable/chunks/singletons-69338d65.js"];
export const stylesheets = [];
export const fonts = [];
